import { SubMenuLink } from '@globalonmedia/ui-components/dist/types/components/header/menu.types'
import {
  FooterContent,
  FooterLink,
} from '@globalonmedia/ui-components/dist/types/components/footer/footer.types'

const socialMediaLinks: FooterLink[] = [
  {
    href: 'https://www.facebook.com/DailyForex/',
    title: 'Facebook',
    icon: 'fb-white',
  },
  {
    href: 'https://twitter.com/daily_forex',
    title: 'Twitter',
    icon: 'twitter-white',
  },
  {
    href: 'https://t.me/dailyforex1',
    title: 'Telegram',
    icon: 'telegram-white',
  },
  {
    href: 'https://www.linkedin.com/company/daily-forex-ltd-',
    title: 'Linkedin',
    icon: 'linkedin-white',
  },
  {
    href: 'https://www.youtube.com/c/Dailyforexcom',
    title: 'Youtube',
    icon: 'youtube-white',
  },
]

const mobileAppsLinks: FooterLink[] = [
  {
    href: 'https://offers.dailyforex.com/lp2/dailyforex-app/',
    title: 'Download our iOS app',
    icon: 'app-store',
  },
  {
    href: 'https://offers.dailyforex.com/lp2/dailyforex-app/',
    title: 'Download our Google Play app',
    icon: 'google-play',
  },
]

const misc: SubMenuLink[] = [
  {
    title: 'terms of service',
    href: 'https://www.dailyforex.com/tos',
  },
  {
    title: 'privacy policy',
    href: 'https://www.dailyforex.com/privacy-policy',
  },
]

const contacts: SubMenuLink[] = [
  {
    title: 'about us',
    href: 'https://www.dailyforex.com/aboutus',
  },
  {
    title: 'contact us',
    href: 'https://www.dailyforex.com/contactus',
  },
  {
    title: 'faq',
    href: 'https://www.dailyforex.com/faq',
  },
]

export const footerContent: FooterContent = {
  socialMedia: socialMediaLinks,
  mobileApps: mobileAppsLinks,
  miscLinks: misc,
  contactLinks: contacts,
}

export const footerText =
  'Risk Disclaimer: DailyForex will not be held liable for any loss or damage resulting from reliance on the information contained within this website including market news, analysis, trading signals and Forex broker reviews. The data contained in this website is not necessarily real-time nor accurate, and analyses are the opinions of the author and do not represent the recommendations of DailyForex or its employees. Currency trading on margin involves high risk, and is not suitable for all investors. As a leveraged product losses are able to exceed initial deposits and capital is at risk. Before deciding to trade Forex or any other financial instrument you should carefully consider your investment objectives, level of experience, and risk appetite. We work hard to offer you valuable information about all of the brokers that we review. In order to provide you with this free service we receive advertising fees from brokers, including some of those listed within our rankings and on this page. While we do our utmost to ensure that all our data is up-to-date, we encourage you to verify our information with the broker directly.'
